import ManageFicheConsultation from '@/views/parametres/configs/param-fiche-medical/manage-fiche-consultation'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'liste-fiche-consultation',
    components: {
        ManageFicheConsultation
    },
    props: {
        selected_consultation: Object,
        info_user: Object,
        liste_autre_consultations: Array,
        activeRole: Object
    },
    data() {
        return {
            selected_fiche: {},
            liste_sections: [],
            fields: [
				'fiche', 'auteur', 'statut',  { key: 'actions', label: 'Action.s' }
			],
			filter_fiche: "",
			perPage: -1,
			currentPage: 1,

            fiche_loading: true,
            fiche_empty: false,
            fiche_consultations: [],

            modal_toggler: 0,
            has_access: false,
            access_checker_loading: true
        }
    },

    computed: {

    },

    mounted() {
        this.selectListeFicheConsultation()
        this.checkUserAccessToTypeConsultation()
    },

    methods: {
        selectListeFicheConsultation() {
            this.fiche_loading = true
            store_fiche.getListeFicheConsultation(this.selected_consultation.id).then((fiches) => {
                this.fiche_consultations = fiches

                if (fiches.length == 0) {
                    this.fiche_empty = true
                } else {
                    this.fiche_empty = false
                }
                this.fiche_loading = false
            })
        },

        addFiche() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0

            $('.add-fiche').modal('show')
        },

        configurer(fiche_data) {
            let data = {
                fiche_data: fiche_data,
                go_to_page: 'liste_section'
            }
            this.$emit('emitGoTo', data)
        },

        checkUserAccessToTypeConsultation() {
            this.access_checker_loading = true
            const data = {
                data_type: 'type_consultation',
                user_id: this.info_user.id,
                data_id: this.selected_consultation.id
            }

            store_fiche.checkUserAccessOnTypePrestation(data).then((response) => {
                
                if (response.success) {
                    this.has_access = response.has_access
                } else {
                    this.has_access = 0
                }

                this.access_checker_loading = false
            }).catch(() => {
                this.access_checker_loading = false
                this.has_access = 0
            })
        },

        configDefaultFiche() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.c-default').modal('show')
        }
    }
}